import React, {useEffect, useRef, useState} from "react";
import PropTypes from 'prop-types'
import Message from "../Utils/Message";
import Typography from "@material-ui/core/Typography";
import request from "../../../../../../Services/API/Requests";
import Loading from "../../../../../../Utils/Loading/Loading";
import ChatInput from "../Utils/ChatInput";
import Divider from "@material-ui/core/Divider";

const QueryChat = ({sourceId, styles, isChatBot, readOnly, ourUser}) => {
    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState({message: ""});
    const [loading, setLoading] = useState(false);
    const currentUserId = JSON.parse(sessionStorage.getItem('user')).user.id;
    const messageEnd = useRef();
    const scrollContainer = useRef();
    useEffect(() => {
        let timer = null;
        if (sourceId) {
            fetchMessages();
            timer = setInterval(() => {
                async function getMessages() {
                    await fetchMessages();
                }

                getMessages();
            }, 5000);
        }
        return () => {
            clearInterval(timer)
        }
    }, [sourceId, isChatBot]);

    //scroll to bottom if newMessage
    useEffect(() => {
        //messageEnd.current.scrollIntoView({behavior: 'smooth'})
        //scrollContainer.current.scrollTo(0, scrollContainer.current.getBoundingClientRect().height)
        scrollContainer.current.scrollTop = scrollContainer.current.scrollHeight
    }, [messages.length]);

    const fetchMessages = async () => {
        try {
            setLoading(true);
            const messages = await request({
                url: "/chat/getMessages",
                method: "POST",
                data: {
                    chatId: sourceId,
                    isChatBot
                }
            });
            setMessages(messages);
            setLoading(false)
        } catch (e) {
            setLoading(false);
        }
    };
    const sendMessage = async () => {
        //get from params url and set message
        try {
            await request({
                url: 'message/create',
                method: 'POST',
                data: {chat: sourceId, text: message.message}
            });
            setMessage('');
            await fetchMessages();
        } catch (e) {
            console.log(e)
        }
    };
    return (
        <div style={{
            width: styles.width,
            height: styles.height,
            margin: styles.margin,
            padding: 2,
        }}>
            <div style={{
                // boxShadow: "inset 0px 0px 2.8px 1px rgba(209,209,209,1)",
                border: '1px solid rgba(209,209,209,1)',
                borderRadius: 5,
                height: '100%'
            }}>
                {loading && <Loading/>}
                <div style={{
                    padding: '5px',
                    display: 'flex',
                    flexDirection: "column",
                    overflow: 'auto',
                    height: 'calc(100% - 38px)',
                }}
                     ref={scrollContainer}
                >
                    {messages.length > 0 ? (
                        messages.map((message) => {
                            return (
                                <Message
                                    key={message.id}
                                    initiator={message.initiator}
                                    initiatorName={message.initiatorName}
                                    dateTime={message.dateTime}
                                    text={message.text}
                                    currentUserId={currentUserId}
                                    ourUser={ourUser}
                                />
                            )
                        })
                    ) : (
                        <div style={{
                            height: '100%',
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <Typography color={"textSecondary"}>No Messages</Typography>
                        </div>
                    )}
                    <span ref={messageEnd}> </span>
                </div>
                {!readOnly && (
                    <>
                        <Divider/>
                        <ChatInput
                            value={message}
                            onChangeMessage={(value) => setMessage({message: value})}
                            onSendMessage={sendMessage}
                            sourceId={sourceId}
                        />
                    </>
                )}
            </div>
        </div>
    )
};
QueryChat.propTypes = {
    readOnly: PropTypes.bool,
    isChatBot: PropTypes.bool,
    sourceId: PropTypes.string
}

QueryChat.defaultProps = {
    styles: {
        width: 300,
        height: 600
    }
};

export default QueryChat;


